<template>
  <AdvicesCategoryModule
    :module-content="content"
    :page-articles="pageArticles"
    :total-page-size="totalPageSize"
    :current-page-index="currentPageIndex"
    data-luko-tracking="Page-Advice_slug"
  />
</template>

<script>
import { formatMetaDatas } from '~/utils/metaData'
import AdvicesCategoryModule from '~/modules/AdvicesCategory'

const PAGE_LENGTH = 10

export default {
  name: 'AdviceCategory',

  head() {
    const heroData = this.content.body.find(
      (s) => s.slice_type === 'hero'
    )?.primary

    const defaultMeta = {
      twitter_title: heroData?.title[0]?.text,
      twitter_description: heroData?.subtitle[0]?.text,
      twitter_image: heroData?.background?.url,
    }

    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    AdvicesCategoryModule,
  },

  async asyncData({ app, $prismic, store, params, error }) {
    try {
      if (params.page <= 1) {
        throw new Error('Page not exist')
      }

      const {
        data: content,
        id: documentId,
        alternate_languages,
      } = await $prismic.api.getByUID('advices_category_page', params.slug, {
        lang: app.i18n.localeProperties.prismicIso,
      })

      store.dispatch('setAlternateLanguages', alternate_languages)
      store.commit('page/UPDATE', {
        theme: '2021Q4-pink',
      })

      const currentPageIndex = parseInt(params.page) || 1
      const { results: pageArticles, total_results_size } =
        await $prismic.api.query(
          [
            $prismic.predicates.at('document.type', 'advice_page'),
            $prismic.predicates.at('my.advice_page.category_page', documentId),
          ],
          {
            lang: app.i18n.localeProperties.prismicIso,
            orderings: content.is_alphabetical_ordered
              ? '[my.advice_page.keyword, my.advice_page.hero_title]'
              : undefined,
            page: currentPageIndex,
            pageSize: PAGE_LENGTH,
          }
        )

      return {
        content,
        metaDatas: content.body1 || [],
        pageArticles,
        totalPageSize:
          total_results_size % PAGE_LENGTH > 0
            ? parseInt(total_results_size / PAGE_LENGTH) + 1
            : parseInt(total_results_size / PAGE_LENGTH),
        currentPageIndex,
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>

<style></style>
